module.exports = __webpack_public_path__ + "img/9.0809787f.png";